import useApiCall from "hooks/useApiCall";
import { forgotPassword } from "api/services/user-service";

export const useForgotPassword = () => {
    const { callAPI, loading } = useApiCall(forgotPassword, 'forgotPasswordPage.emailSent', 'forgotPasswordPage.emailSendingError');

    return { processForgotPassword: callAPI, forgotPasswordPending: loading}
}